var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoadingOverlay',{staticStyle:{"z-index":"99999"},attrs:{"active":_vm.active,"is-full-page":_vm.fullPage,"color":"blue","width":96,"height":96},on:{"update:active":function($event){_vm.active=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }